import { PageNumbers } from '@process-creative/slate-ajax-collection';
import $ from 'jquery';

export class CustomPageNumbers extends PageNumbers {
  redraw() {
    // Called anytime the filters are updated, products are loaded, pages are changed etc.
    let x = '';
    // let page = this.pagination.getCurrentPage();//Short hand
    // let totalPages = this.pagination.getTotalPages();

    // vendor-todo: fix the total pages and current page
    const paginationElement = document.querySelector('[data-collection-template-pagination]');
    const perPageCount = paginationElement.getAttribute('data-per-page-count');
    let totalPages = paginationElement.getAttribute('data-total-pages');
    totalPages = Math.ceil(totalPages);
    const initial_url = window.location.href;
    const url = 'all-products';
    const products = document.querySelectorAll('[data-product-thumbnail]');

    let currentPage;
    if (initial_url.indexOf('?') === -1) {
      currentPage = 1;
      paginationElement.classList.remove('hide');
    } else {
      const currentPageQuery = initial_url.indexOf('page=') >= 0 ? parseInt(initial_url.split('page=')[1]?.split('&')[0], 10) : 1;
      currentPage = currentPageQuery;

      if (initial_url.indexOf('category') >= 0) {
        paginationElement.classList.toggle('hide', products.length < perPageCount);
      }
    }

    const page = currentPage;

    if (initial_url.indexOf('page=') >= 0 && initial_url.indexOf('&') === -1 && products.length <= parseInt(perPageCount, 10)) {
      paginationElement.classList.remove('hide');
    } else if (initial_url.indexOf('page=') === -1 && initial_url.indexOf('category') === -1 && initial_url.indexOf('?sort_by') >= 0 && products.length <= parseInt(perPageCount, 10)) {
      paginationElement.classList.remove('hide');
    }

    // Prev Button
    if (page > 1) {
      // let url = this.template.settings.getSettingsUrl({ page: (page - 1) });
      x += ` <span class="prev"><a href="${url}" title=""></a></span> `;
      PageNumbers.prototype.onPrevClick = function () {
        this.pagination.setPage(page - 1);
      };
    }

    // First, let's generate an array of numbers we want to draw (we always draw 1 and totalPages())
    let numbers = [];
    if (totalPages > 1) numbers = [1, totalPages];

    // Now add numbers page-2,page-1,page,page+1,page+2
    for (let i = page - 2; i <= page + 2; i++) {
      // Already in the list
      if (numbers.indexOf(i) !== -1) continue;
      if (i < 1) continue;
      if (i > totalPages) continue;
      numbers.push(i);
    }
    // eslint-disable-next-line id-length
    numbers = numbers.sort((l, r) => l - r);

    // Now we have a list of numbers, we can try and find gaps
    numbers.forEach((num, i) => {
      if (num === 0) return;
      const isCurrent = num === page;

      x += ` <span class="page ${isCurrent ? 'current' : ''}">`;
      if (!isCurrent) {
        const sUrl = this.template.settings.getSettingsUrl({ page: num });
        x += `<a href="${sUrl}" title="">`;
      }

      x += `${num}`;

      if (!isCurrent) x += '</a>';
      x += '</span> ';

      // Is there a gap?
      const nextExpected = num + 1;
      if (
        typeof numbers[i + 1] !== typeof undefined &&
        numbers[i + 1] !== nextExpected
      ) {
        x += ' <span class="deco">…</span> ';
      }
    });

    // Next Button
    if (page < totalPages) {
      const sUrl = this.template.settings.getSettingsUrl({
        page: page + 1,
      });

      x += ` <span class="next"><a href="${sUrl}" title=""></a></span> `;
    }

    this.container.html(x);
  }

  onPageChange() {
    super.onPageChange();
    const top = $('[data-collection-template-products]').offset().top;
    $('html,body').animate({ scrollTop: top });
  }
}
